import React from "react";
import { Box, Typography } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";
import { FullBleed } from "../review/ReviewSections"; // 👈 path apne folder structure ke hisab se adjust karo

export type ProofStripItem = {
    icon: string;
    badgeColor: string;
    title: string;
    description: string;
};

export const PROOF_STRIP_ITEMS: ProofStripItem[] = [
    {
        icon: "★",
        badgeColor: QUIZ.color.green,
        title: "4.8 out of 5 on Trustpilot",
        description: "From thousands of UK dog owners.",
    },
    {
        icon: "★",
        badgeColor: QUIZ.color.purple,
        title: "Rated 94% by All About Dog Food",
        description: "Independently rated as the UK's best truly fresh food.",
    },
    {
        icon: "🐾",
        badgeColor: QUIZ.color.blue,
        title: "Over 1 million bowls licked clean",
        description: "By happier, healthier dogs across the UK.",
    },
];

export default function ProofStrip() {
    return (
        <FullBleed>
            <Box
                sx={{
                    bgcolor: QUIZ.color.brown,
                    borderTop: `1px solid ${QUIZ.color.cream3}`,
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        px: { xs: "28px", md: "24px" },
                        py: { xs: "28px", md: "56px" },
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        gap: { xs: "20px", md: "48px" },
                        maxWidth: { xs: "100%", md: 1240 },
                        mx: "auto",
                        alignItems: { xs: "stretch", md: "flex-start" },
                    }}
                >
                    {PROOF_STRIP_ITEMS.map((item) => (
                        <Box
                            key={item.title}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "row", md: "column" },
                                alignItems: { xs: "flex-start", md: "center" },
                                gap: { xs: "12px", md: "16px" },
                                textAlign: { xs: "left", md: "center" },
                                flex: { xs: "initial", md: 1 },
                                minWidth: 0,
                            }}
                        >
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    width: { xs: 50, md: 52 },
                                    height: { xs: 50, md: 52 },
                                    borderRadius: "50%",
                                    bgcolor: item.badgeColor,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Typography
                                    component="span"
                                    aria-hidden
                                    sx={{ fontSize: { xs: 22, md: 24 }, lineHeight: 1 }}
                                >
                                    {item.icon}
                                </Typography>
                            </Box>

                            <Box sx={{ minWidth: 0 }}>
                                <Typography
                                    sx={{
                                        fontFamily: QUIZ.font.display,
                                        fontWeight: 900,
                                        fontSize: { xs: 17, md: 22 },
                                        color: QUIZ.color.white,
                                        textTransform: "uppercase",
                                        lineHeight: 1.25,
                                        // Reserve two heading lines on desktop so a short
                                        // title (such as Trustpilot) aligns with the others.
                                        minHeight: { md: "55px" },
                                        display: { md: "flex" },
                                        alignItems: { md: "center" },
                                        justifyContent: { md: "center" },
                                    }}
                                >
                                    {item.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: QUIZ.font.body,
                                        fontSize: { xs: 14, md: 16 },
                                        color: QUIZ.color.cream3,
                                        mt: "4px",
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {item.description}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </FullBleed>
    );
}
